import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DeleteCoupon } from '../../redux/Slices/CouponSlice'
import notify from '../UseNotification'

const UseAdminDeleteCoupon = (item) => {
    const dispatch = useDispatch()
    const [show, setShow] = useState(false)
    const [loading, setLoading] = useState(true)
    const { deleteCoupon } = useSelector(state => state.CouponReducer)

    // handle close modal
    const handleClose = () => {
        setShow(false)
    }

    // handle show modal
    const handleShow = () => {
        setShow(true)
    }

    // handle delete coupone 
    const HandleDeleteCoupon = async () => {
        handleClose();
        setLoading(true)
        await dispatch(DeleteCoupon(item._id))
        setLoading(false)

    }

    // hanlde response of delete request 
    useEffect(() => {
        if (loading === false) {
            if (deleteCoupon.status === "fail") {
                notify("please try again", "error")
                return;
            } else {
                notify("Coupon deleted", "success")
                setTimeout(() => {
                    window.location.reload(false)
                }, 1000);
            }
        }
    }, [loading])
    return [show, handleClose, handleShow, HandleDeleteCoupon]
}

export default UseAdminDeleteCoupon
